// extracted by mini-css-extract-plugin
export default {"enable2fa":"Enable2FA_enable2fa__V6v-F","verify2FA":"Enable2FA_verify2FA__Nn1-L"};